import { RootState } from "interfaces/generics.type";
import NoSearchResultMessage from "modules/search/no-result/NoSearchResultMessage";
import { useSelector } from "react-redux";

function NoProductsRegular() {
  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  return (
    <>
      <NoSearchResultMessage searchKeyword={null} currentVehicle={selectedVehicle} />
    </>
  );
}

export default NoProductsRegular;
